// extracted by mini-css-extract-plugin
export var navbarSubLink = "D_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "D_tV d_f0 d_dB";
export var subPageLink = "D_gf d_gf";
export var burger = "D_vC";
export var sublinkSize = "D_vD";
export var linkSize = "D_vF";
export var Link = "D_r7 s_r7 s_rs s_rN";